import { useState } from "react"
import { postAccessScan } from "../api/apiService"
import { useAuth } from "../context/authcontext"
import { useScan } from "../context/scanContext"

export const useTicketValidation = () => {
    const validationResponseStub = {
        isValid: false,
        message: "",
        ticketName: "",
        ticketNumber: ""
    }

    const [isLoading, setIsLoading] = useState(false)
    const [validationResponse, setValidationResponse] = useState(validationResponseStub)
    const { user } = useAuth()
    const { scanMode, controlPoint, products } = useScan()

    const validateTicket = (code, onValidationComplete) => {
        setIsLoading(true)
        postAccessScan(user.Event.Id, controlPoint.Id, code)
            .then((items) => {
                var response = {
                    isValid: items.Result === "Valid" ? true : false,
                    message: items.Title,
                    ticketNumber: items.Number ? items.Number : "Inconnu",
                    ticketName: items.TicketName ? JSON.parse(items.TicketName).fr : "Inconnu"
                }
                setValidationResponse(response)
                // La réponse est transmise à la callback : au moment où elle
                // s'exécute, le state du composant n'est pas encore à jour.
                if (onValidationComplete) {
                    onValidationComplete(response)
                }
            })
            // Réseau instable en site événementiel : sans ce catch, l'écran
            // restait bloqué sur le chargement au lieu d'afficher une erreur.
            .catch(() => {
                const failure = {
                    isValid: false,
                    message: "Erreur de communication avec le serveur",
                    ticketNumber: "Inconnu",
                    ticketName: "Inconnu"
                }
                setValidationResponse(failure)
                if (onValidationComplete) {
                    onValidationComplete(failure)
                }
            })
        setIsLoading(false)
    }

    return { validateTicket, isLoading, validationResponse }
}